module.exports = __webpack_public_path__ + "static/media/nimes_roemermuseum.905b72e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_roemermuseum.png
// module id = 735
// module chunks = 0